import type { GridEntity, DefaultGrid } from './schemas';
import { createEntityMeta } from '../utils';

const baseDefaults = {
    id: '',
    parentId: '',
    entityType: 'grid' as const,
    children: [] as unknown[][],
};

export const createDefaultDefaultGrid = (): DefaultGrid => ({
    ...baseDefaults,
    meta: createEntityMeta(),
    version: 0,
    entitySubType: 'default',
    props: {
        variant: 0,
        gapX: {
            desktop: {
                value: 0,
                unit: 'px',
            },
        },
        gapY: {
            desktop: {
                value: 0,
                unit: 'px',
            },
        },
        rowCellWidth: {
            desktop: [],
        },
    },
});

export const createDefaultGrid = (entitySubType: 'default' = 'default'): GridEntity => {
    return createDefaultDefaultGrid();
};
